// // src/components/chat/ChatSidebar.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import { useNavigate, useLocation } from "react-router-dom";

// export default function ChatSidebar() {
//   const [contacts, setContacts] = useState([]);
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     async function loadContacts() {
//       try {
//         const res = await api.get("/chat/contacts");
//         setContacts(res.data);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//     loadContacts();
//   }, []);

//   function openChat(contactId) {
//     const params = new URLSearchParams(location.search);
//     const listingId = params.get("listingId") || "";

//     navigate(`/messages?withUserId=${contactId}&listingId=${listingId}`);
//   }

//   return (
//     <div>
//       <h3 className="text-lg font-semibold mb-4">Chats</h3>

//       {contacts.length === 0 && (
//         <p className="text-gray-400 text-sm">No conversations yet</p>
//       )}

//       {contacts.map((contact) => (
//         <div
//           key={contact.id}
//           className="p-3 rounded-xl hover:bg-gray-100 cursor-pointer"
//           onClick={() => openChat(contact.id)}
//         >
//           <div className="font-medium">{contact.fullName}</div>
//           <div className="text-xs text-gray-500">{contact.email}</div>
//         </div>
//       ))}
//     </div>
//   );
// }









// src/components/chat/ChatSidebar.jsx
import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import { useNavigate, useLocation } from "react-router-dom";

export default function ChatSidebar() {
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function loadContacts() {
      try {
        const res = await api.get("/chat/contacts");
        console.log("Chat contacts:", res.data);
        setContacts(res.data);
        setError("");
      } catch (err) {
        console.error("Error loading contacts:", err);
        setError(
          err?.response?.data?.message || "Failed to load chat contacts"
        );
      }
    }
    loadContacts();
  }, []);

  function openChat(contactId) {
    const params = new URLSearchParams(location.search);
    const listingId = params.get("listingId") || "";
    navigate(`/messages?withUserId=${contactId}&listingId=${listingId}`);
  }

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Chat Person</h3>

      {error && (
        <p className="text-xs text-red-500 mb-2">
          {error}
        </p>
      )}

      {contacts.length === 0 && !error && (
        <p className="text-gray-400 text-sm">No conversations yet</p>
      )}

      {contacts.map((contact) => (
        <div
          key={contact.id}
          className="p-3 rounded-xl hover:bg-gray-100 cursor-pointer"
          onClick={() => openChat(contact.id)}
        >
          <div className="font-medium">{contact.fullName}</div>
          <div className="text-xs text-gray-500">{contact.email}</div>
        </div>
      ))}
    </div>
  );
}
